import { API } from "aws-amplify";

export const foodCourtGet = async (endpoint: string, token: string) => {
  if (!endpoint) {
    return;
  }

  const data = await API.get(
    process.env.REACT_APP_API_NAME,
    endpoint,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

  return data;
};

export const foodCourtPut = async (endpoint: string, token: string, data: any) => {
  if (!endpoint) {
    return;
  }

  const result = await API.put(
    process.env.REACT_APP_API_NAME,
    endpoint,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: data,
    },
  );

  return result;
};

export const foodCourtDelete = async (endpoint: string, token: string) => {
  if (!endpoint) {
    return;
  }

  const result = await API.del(
    process.env.REACT_APP_API_NAME,
    endpoint,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
    },
  );

  return result;
};

export const foodCourtPost = async (endpoint: string, token: string, data: any) => {
  if (!endpoint) {
    return;
  }

  const result = await API.post(
    process.env.REACT_APP_API_NAME,
    endpoint,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: data,
    },
  );

  return result;
};

/**
 * Response shape from the delivery upload-url API (Lambda-style with body).
 */
export type DeliveryUploadUrlResponse = {
  statusCode?: number;
  headers?: Record<string, string>;
  /** Body may be parsed (object) or stringified (string) depending on Lambda integration */
  body?:
    | {
        uploadUrl: string;
        key: string;
        expiresIn: number;
      }
    | string;
  /** If the API returns the body unwrapped */
  uploadUrl?: string;
};

/**
 * Requests a presigned S3 URL for uploading a delivery CSV file.
 * Backend returns a Lambda-style response with body.uploadUrl, key, and expiresIn.
 *
 * @param token - Cognito access token for Authorization header
 * @param fileName - Name of the CSV file to upload (e.g. "delivery-test.csv")
 * @returns Promise resolving to the API response (upload URL in body.uploadUrl)
 */
export const getDeliveryUploadUrl = async (
  token: string,
  fileName: string
): Promise<DeliveryUploadUrlResponse> => {
  const endpoint = "/upload-url";
  const body = { fileName };
  return foodCourtPost(endpoint, token, body) as Promise<DeliveryUploadUrlResponse>;
};

// TODO: Remove this
export function MultiFetcher(token: string, ...urls: any[]) {
  return Promise.all(urls.map((url) => foodCourtGet(url, token)));
}

export function MultiFoodFetcher(token: string, ...urls: any[]) {
  return Promise.all(urls.map((url) => foodCourtGet(url, token)));
}